<template> 
    <div class='body-job index'>
        <div class='container'>
            <div class='box-banner'>
                <img src='/static/image/job/banner-02.png'>
            </div>
            <div class='box-cont'>
                <p>如果你享受游戏，</p>
                <p>如果你热爱游戏事业，</p>
                <p>如果你喜欢有挑战性但富有乐趣的工作，</p>
                <p>如果你希望加入严谨纪律但又朝气勇敢博创新的团队，</p>
                <br>
                <br>
                <button class='btn btn-primary btn-circle' 
                    @click='toUrl("/job/detail")'>
                    加入我们
                </button>
                <br>
                <br>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import Request from '@/common/Request'
import Common from '@/common/Common'
export default {
    created : function(){
        window.scrollTo(0, 0)
    },
    methods : {
        //跳转
        toUrl : function(url){
            Common.toUrl(url)
            return true
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/job/Index.vue